import type { UltrareviewMode } from './schema';

export const DEFAULT_ULTRAREVIEW_MODE: UltrareviewMode = 'manual';
